export default "__VITE_ASSET__D0B8psg3__"